import { useEffect, useState } from "react";

function TableParameter({ cultivarRecommendationsAnalysisResult }) {
  const [tableCultivargResult, setTableCultivargResult] = useState([]);
  useEffect(() => {
    const result = cultivarRecommendationsAnalysisResult.reduce(
      (nineToThree, cultivar) => {
        cultivar.resistances.map((resistance) => {
          const existsResistance = nineToThree.find(
            (item) => item.id === resistance.id
          );
          if (existsResistance) {
            existsResistance.cultivars.push({
              average: cultivar.average,
              id: cultivar.id,
              name: cultivar.name,
              resistance: {
                priority: resistance.priority,
                rate: resistance.rate,
                resistance: resistance.resistance,
              },
            });
          } else {
            nineToThree.push({
              category: resistance.category,
              id: resistance.id,
              name: resistance.name,
              cultivars: [
                {
                  average: cultivar.average,
                  id: cultivar.id,
                  name: cultivar.name,
                  resistance: {
                    priority: resistance.priority,
                    rate: resistance.rate,
                    resistance: resistance.resistance,
                  },
                },
              ],
            });
          }
        });
        return nineToThree;
      },
      []
    );

    setTableCultivargResult(result);
  }, []);

  return (
    <div className="flex flex-col justify-center items-center mt-5">
      <div className="flex flex-row justify-center items-center h-full w-full">
        <div
          className="w-[160px] text-center py-2 px-1 font-bold text-lg !font-[B-Nazanin] rounded-tr-[5px]"
        >
          اولویت انتخاب :
        </div>

        {cultivarRecommendationsAnalysisResult.map((item, index) => (
          <div
            key={index}
            className={`w-[160px] py-2 text-center px-1 text-lg ${cultivarRecommendationsAnalysisResult.length - 1 === index &&
              "rounded-tl-[5px]"
              }  font-bold !font-[B-Nazanin]`}
          >
            {index + 1}
          </div>
        ))}
      </div>
      <div className="flex flex-row justify-center items-center h-full w-full !text-white">
        <div
          className="w-[160px] h-full py-2 px-1 text-center text-[16px] font-bold !font-[B-Nazanin] bg-[#460F81CC] rounded-tr-[5px]"
          style={{
            borderTop: "1.5px solid black",
            borderRight: "1.5px solid black",
            borderBottom: "0.75px solid black",
            borderLeft: "0.75px solid black",
          }}
        >
          رقم
        </div>
        {cultivarRecommendationsAnalysisResult.map((item , index) => (
          <div
            key={item.id}
            className={`w-[160px] py-2 h-full px-1 text-center  font-bold !font-[B-Nazanin] bg-[#460F81CC] ${index === 2 ? "rounded-tl-[5px]" : ""} `}
            style={{
              borderTop: "1.5px solid black",
              borderRight: "0.75px solid black",
              borderBottom: "0.75px solid black",
              borderLeft: "0.75px solid black",
            }}
          >
            {item.name}
          </div>
        ))}
      </div>
      {tableCultivargResult.map((cultivar, index) => (
        <div
          key={index}
          className="flex flex-row justify-center items-center h-full w-full"
        >
          <div
            className={`w-[160px] h-full px-1 py-2 text-center text-[16px] font-bold !font-[B-Nazanin] ${tableCultivargResult?.length - 1 === index && "rounded-br-[5px]"
              } ${cultivar.category === "morphophysiologicals"
                ? "bg-[#D1B4F133]"
                : "bg-[#3FB0E033]"
              } `}
            style={{
              borderTop: "1.5px solid black",
              borderRight: "1.5px solid black",
              borderBottom: "0.75px solid black",
              borderLeft: "0.75px solid black",
            }}
          >
            {cultivar.name}
          </div>
          {cultivar.cultivars.map((item, i) => (
            <div
              key={i}
              className={`w-[160px] py-2 h-full px-1 text-center  font-bold !font-[B-Nazanin] ${tableCultivargResult?.length - 1 === index &&
                cultivar.cultivars.length - 1 === i &&
                "rounded-bl-[5px]"
                }`}
              style={{
                borderTop: "1.5px solid black",
                borderRight: "0.75px solid black",
                borderBottom: "0.75px solid black",
                borderLeft: "0.75px solid black",
              }}
            >
              {item.resistance.resistance === null
                ? "----"
                : item.resistance.resistance}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

export default TableParameter;
